import styled from 'styled-components';

import { List } from '@zillow/constellation';

export const StyledSubTitleContainer = styled.div`
    display: flex;
    flex-direction: row;
`;

export const StyledListItem = styled(List.Item)`
    && {
        padding: 0;
    }
`;
